import { gql } from '@apollo/client';

/**
 * 单任务照片凭证。
 *
 * 按需查询（打开留证弹窗时），不随任务列表返回 —— 附件只在上游 getTaskDetail 里，
 * 随列表返回会对每个任务多打一次 RPC。
 *
 * 返回的 fileUrl 是**短时效预签名 URL**（私有桶给不了长期链接），弹窗重开需重新查询。
 */
export const WORKBENCH_TASK_PHOTOS = gql`
  query WorkbenchTaskPhotos($warehouseId: Long!, $taskId: Long!) {
    workbenchTaskPhotos(warehouseId: $warehouseId, taskId: $taskId) {
      fileUrl
      fileName
      uploadedByName
      uploadedAt
    }
  }
`;
